(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enova-espacios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('enova-espacio')) return;

    class EnovaEspacio extends HTMLElement {
      connectedCallback() {
        this.card = this.querySelector('.ees__card');
        this.items = Array.from(this.querySelectorAll('[data-ees-select]'));
        if (!this.items.length) return;

        // Solo marca la selección. Abrir el quickview es responsabilidad del
        // handler delegado de Minimog, que escucha .m-product-quickview-button.
        this.onSelect = (event) => {
          var trigger = event.target.closest('[data-ees-select]');
          if (!trigger || !this.contains(trigger)) return;
          this.select(trigger.dataset.index);
        };

        this.addEventListener('click', this.onSelect);
      }

      select(index) {
        if (!index) return;
        this.dataset.selected = index;
        this.items.forEach(function (item) {
          if (item.dataset.index === index) {
            item.dataset.active = 'true';
            item.setAttribute('aria-current', 'true');
          } else {
            delete item.dataset.active;
            item.removeAttribute('aria-current');
          }
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onSelect);
      }
    }

    window.customElements.define('enova-espacio', EnovaEspacio);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enova-favoritos-enkasa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('enova-favoritos')) return;

    class EnovaFavoritos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fav-track]');
        this.prevBtn = this.querySelector('[data-fav-prev]');
        this.nextBtn = this.querySelector('[data-fav-next]');
        this.dotsWrap = this.querySelector('[data-fav-dots]');
        this.controls = this.querySelector('[data-fav-controls]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.rebuild = this.rebuild.bind(this);

        this.prevBtn && this.prevBtn.addEventListener('click', () => this.scrollPage(-1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.scrollPage(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.rebuild);

        this.rebuild();
        setTimeout(this.rebuild, 300); // re-cálculo cuando imágenes/layout asientan
      }

      pageW() { return this.track.clientWidth; }
      pages() { return Math.max(1, Math.ceil(this.track.scrollWidth / this.pageW())); }
      current() { return Math.round(this.track.scrollLeft / this.pageW()); }

      scrollPage(dir) {
        this.track.scrollBy({ left: dir * this.pageW(), behavior: 'smooth' });
      }
      scrollToPage(i) {
        this.track.scrollTo({ left: i * this.pageW(), behavior: 'smooth' });
      }

      rebuild() {
        var overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        if (this.controls) this.controls.style.display = overflow ? 'flex' : 'none';

        if (this.dotsWrap) {
          var n = overflow ? this.pages() : 0;
          this.dotsWrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'fav__dot';
            b.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
            (function (idx, self) {
              b.addEventListener('click', function () { self.scrollToPage(idx); });
            })(i, this);
            this.dotsWrap.appendChild(b);
          }
        }
        this.update();
      }

      update() {
        var t = this.track;
        var atStart = t.scrollLeft <= 2;
        var atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
        if (this.dotsWrap) {
          var cur = this.current();
          var dots = this.dotsWrap.children;
          for (var i = 0; i < dots.length; i++) {
            dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
          }
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.rebuild);
      }
    }

    window.customElements.define('enova-favoritos', EnovaFavoritos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enova-hot-sales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements.get('enova-hot-sales')) {
      class EnovaHotSales extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ehs-track]');
          this.prevBtn = this.querySelector('[data-ehs-prev]');
          this.nextBtn = this.querySelector('[data-ehs-next]');
          if (!this.track) return;

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
          this.autoDelay = parseInt(this.dataset.autoplaySpeed, 10) || 3000;

          this.update = this.update.bind(this);
          this.advance = this.advance.bind(this);
          this.onVisibility = this.onVisibility.bind(this);
          this.onPrev = () => this.nudge(-1);
          this.onNext = () => this.nudge(1);

          this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
          this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);

          if (this.autoplay) {
            this.addEventListener('pointerenter', () => this.stopAuto());
            this.addEventListener('pointerleave', () => this.startAuto());
            this.addEventListener('focusin', () => this.stopAuto());
            this.addEventListener('focusout', () => this.startAuto());
            // Al arrastrar con el dedo el autoplay pelearía con el gesto.
            this.track.addEventListener('touchstart', () => this.stopAuto(), { passive: true });
            this.track.addEventListener('touchend', () => this.startAuto(), { passive: true });
            document.addEventListener('visibilitychange', this.onVisibility);
            this.startAuto();
          }

          this.update();
          // Re-check once images/layout settle
          setTimeout(this.update, 300);
        }

        // Ancho de una tarjeta + su gap: el carrusel avanza de a un producto.
        step() {
          var slide = this.track.querySelector('.ehs__slide');
          if (!slide) return Math.round(this.track.clientWidth * 0.9);
          var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          return slide.getBoundingClientRect().width + gap;
        }

        // Movimiento manual: da la vuelta en los extremos y reinicia el
        // temporizador para no encadenar dos saltos seguidos.
        nudge(dir) {
          var t = this.track;
          var max = t.scrollWidth - t.clientWidth;
          if (dir < 0 && t.scrollLeft <= 2) t.scrollTo({ left: max, behavior: 'smooth' });
          else if (dir > 0 && t.scrollLeft >= max - 2) t.scrollTo({ left: 0, behavior: 'smooth' });
          else t.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
          if (this.autoplay) this.startAuto();
        }

        advance() {
          var t = this.track;
          var atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
          if (atEnd) t.scrollTo({ left: 0, behavior: 'smooth' });
          else t.scrollBy({ left: this.step(), behavior: 'smooth' });
        }

        startAuto() {
          if (!this.autoplay) return;
          this.stopAuto();
          this.autoTimer = setInterval(this.advance, this.autoDelay);
        }

        stopAuto() {
          if (this.autoTimer) clearInterval(this.autoTimer);
          this.autoTimer = null;
        }

        onVisibility() {
          if (document.hidden) this.stopAuto();
          else this.startAuto();
        }

        update() {
          var t = this.track;
          var overflow = t.scrollWidth > t.clientWidth + 2;
          var atStart = t.scrollLeft <= 2;
          var atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
          // Con autoplay el carrusel vuelve al inicio solo, así que las flechas
          // se mantienen activas mientras haya desborde.
          if (this.prevBtn) this.prevBtn.disabled = !overflow || (atStart && !this.autoplay);
          if (this.nextBtn) this.nextBtn.disabled = !overflow || (atEnd && !this.autoplay);
        }

        disconnectedCallback() {
          this.stopAuto();
          window.removeEventListener('resize', this.update);
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      window.customElements.define('enova-hot-sales', EnovaHotSales);
    }

    if (!window.customElements.get('enova-hot-countdown')) {
      var WEEK = 604800;

      class EnovaHotCountdown extends HTMLElement {
        connectedCallback() {
          this.end = parseInt(this.dataset.end, 10) || 0;
          this.repeat = this.dataset.repeat === 'true';
          this.behavior = this.dataset.behavior || 'hide_timer';
          this.designMode = this.dataset.designMode === 'true';

          this.nodes = {
            days: this.querySelector('[data-ehs-days]'),
            hours: this.querySelector('[data-ehs-hours]'),
            minutes: this.querySelector('[data-ehs-minutes]'),
            seconds: this.querySelector('[data-ehs-seconds]')
          };
          if (!this.end || !this.nodes.days) return;

          this.tick = this.tick.bind(this);
          this.tick();
          this.timer = setInterval(this.tick, 1000);
        }

        // Con "repetir cada semana" el plazo se corre en bloques de 7 días
        // hasta caer en el futuro, así el contador nunca queda en cero.
        target(now) {
          var end = this.end;
          if (this.repeat) {
            while (end <= now) end += WEEK;
          }
          return end;
        }

        tick() {
          var now = Math.floor(Date.now() / 1000);
          var diff = this.target(now) - now;

          if (diff <= 0) {
            this.paint(0, 0, 0, 0);
            this.stop();
            if (!this.designMode) this.expire();
            return;
          }

          this.paint(
            Math.floor(diff / 86400),
            Math.floor((diff % 86400) / 3600),
            Math.floor((diff % 3600) / 60),
            diff % 60
          );
        }

        paint(d, h, m, s) {
          var pad = function (n) {
            return n < 10 ? '0' + n : String(n);
          };
          this.nodes.days.textContent = pad(d);
          this.nodes.hours.textContent = pad(h);
          this.nodes.minutes.textContent = pad(m);
          this.nodes.seconds.textContent = pad(s);
        }

        expire() {
          if (this.behavior === 'hide_timer') {
            this.hidden = true;
          } else if (this.behavior === 'hide_section') {
            var section = this.closest('[data-section-type="enova-hot-sales"]');
            if (section) section.hidden = true;
          }
        }

        stop() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }

        disconnectedCallback() {
          this.stop();
        }
      }

      window.customElements.define('enova-hot-countdown', EnovaHotCountdown);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enova-recompensas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__enovaRecompensasBound) return;
    window.__enovaRecompensasBound = true;

    var RETRY_MS = 250;
    var MAX_WAIT_MS = 6000;

    // Las apps montan sus widgets async, así que se reintenta un rato antes de
    // rendirse y caer al enlace de respaldo del bloque.
    function clickWhenReady(card, find, notFoundMsg) {
      var el = find();
      if (el) {
        el.click();
        return;
      }
      var waited = 0;
      card.setAttribute('data-erc-busy', '');
      var timer = setInterval(function () {
        var found = find();
        waited += RETRY_MS;
        if (found) {
          clearInterval(timer);
          card.removeAttribute('data-erc-busy');
          found.click();
        } else if (waited >= MAX_WAIT_MS) {
          clearInterval(timer);
          card.removeAttribute('data-erc-busy');
          var fallback = card.dataset.ercFallback;
          if (fallback) window.location.href = fallback;
          else console.warn('[Enova Recompensas] ' + notFoundMsg);
        }
      }, RETRY_MS);
    }

    // El launcher de Growave vive en un shadow root abierto. Se busca por
    // .gw-launcher y, si cambiara de clase, se cae a cualquier button del root.
    function findGrowaveLauncher() {
      var host = document.querySelector('.gw-rd-popup-widget-placeholder');
      if (!host || !host.shadowRoot) return null;
      return host.shadowRoot.querySelector('.gw-launcher') || host.shadowRoot.querySelector('button');
    }

    function openGrowave(card) {
      clickWhenReady(card, findGrowaveLauncher, 'No se encontró el launcher de Growave.');
    }

    function openFoxkitPopup(card) {
      // Si el popup ya está abierto no hay nada que hacer.
      if (document.querySelector('.foxkit-modal--popup.is-open')) return;
      clickWhenReady(
        card,
        function () {
          return document.querySelector('.foxkit-popup__teaser');
        },
        'No se encontró la pestaña del popup de FoxKit. Si el visitante acaba de cerrarlo, FoxKit lo quita del DOM hasta la siguiente carga.'
      );
    }

    function openKlaviyo(card) {
      var id = (card.dataset.ercFormId || '').trim();
      if (!id) {
        console.warn('[Enova Recompensas] Falta el ID del formulario de Klaviyo en los ajustes del bloque.');
        var fallback = card.dataset.ercFallback;
        if (fallback) window.location.href = fallback;
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-erc-action]');
      if (!card) return;
      event.preventDefault();
      if (card.hasAttribute('data-erc-busy')) return;

      var action = card.dataset.ercAction;
      if (action === 'growave_rewards') openGrowave(card);
      else if (action === 'foxkit_popup') openFoxkitPopup(card);
      else if (action === 'klaviyo_form') openKlaviyo(card);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enova-search-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('enova-search-panel')) return;

    var debounce = function (fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    };

    var escapeHtml = function (str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    };

    var upscaleImage = function (src) {
      if (!src) return '';
      return src.replace(/_\d+x(?=\.|$|\?)/, '_400x').replace(/width=\d+/, 'width=400');
    };

    var ownText = function (el) {
      if (!el) return '';
      var parts = [];
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3) parts.push(node.textContent);
      });
      var text = parts.join('').replace(/\s+/g, ' ').trim();
      if (text) return text;
      var clone = el.cloneNode(true);
      clone.querySelectorAll('span, s').forEach(function (node) { node.remove(); });
      return clone.textContent.replace(/\s+/g, ' ').trim();
    };

    var productHandleFromHref = function (href) {
      var match = String(href || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    };

    var extractPriceHtml = function (item) {
      var onSale = item.querySelector('.m-price--on-sale');
      var nowEl = onSale
        ? item.querySelector('.m-price-item--sale')
        : item.querySelector('.m-price__regular .m-price-item--regular');
      if (!nowEl) nowEl = item.querySelector('.m-price-item--sale, .m-price-item--regular');
      var now = ownText(nowEl);
      if (!now) return '';
      var html = '<span class="ens-pcard__now">' + escapeHtml(now) + '</span>';
      if (!onSale) return html;
      var was = ownText(item.querySelector('.m-price__sale s.m-price-item--regular'));
      var offEl = item.querySelector('.discount-badge');
      var off = offEl ? offEl.textContent.replace(/\s+/g, '').trim() : '';
      if (was) html += '<s class="ens-pcard__was">' + escapeHtml(was) + '</s>';
      if (off) html += '<span class="ens-pcard__off">' + escapeHtml(off) + '</span>';
      return html;
    };

    class EnovaSearchPanel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.panel = this.querySelector('.ens__panel');
        this.input = this.querySelector('[data-ens-input]');
        this.form = this.querySelector('[data-ens-form]');
        this.submitBtn = this.querySelector('[data-ens-submit]');
        this.clearBtn = this.querySelector('[data-ens-clear]');
        this.spinner = this.querySelector('[data-ens-spinner]');
        this.discover = this.querySelector('[data-ens-discover]');
        this.results = this.querySelector('[data-ens-results]');
        this.allBtn = this.querySelector('[data-ens-all]');
        this.lastFocus = null;
        this.cache = {};
        this._productCache = {};
        this.ghost = this.querySelector('[data-ens-ghost]');
        this.phrases = [];
        this._twTimer = null;
        this._twIndex = 0;
        this._twPos = 0;
        this._twDeleting = false;
        this._locked = false;
        this._scrollY = 0;
        this._userInInput = false;
        this._busy = false;
        this._origin = null;
        this.glow = this.querySelector('.ens__glow');

        var phrasesEl = this.querySelector('[data-ens-phrases]');
        if (phrasesEl) {
          try {
            var parsed = JSON.parse(phrasesEl.textContent);
            if (Array.isArray(parsed)) this.phrases = parsed.filter(Boolean);
          } catch (err) {
            this.phrases = [];
          }
        }

        this.onToggle = this.onToggle.bind(this);
        this.onKey = this.onKey.bind(this);
        this.place = this.place.bind(this);
        this.syncGhost = this.syncGhost.bind(this);
        this.onGuardScroll = this.onGuardScroll.bind(this);
        this.pauseTypewriter = this.pauseTypewriter.bind(this);
        this.resumeTypewriter = this.resumeTypewriter.bind(this);
        this.onInputKey = this.onInputKey.bind(this);
        this.onFieldPointer = this.onFieldPointer.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onInput = debounce(this.search.bind(this), 280);

        document.addEventListener('click', this.onToggle);
        this.addEventListener('click', this.onPanelClick.bind(this));
        if (this.input) {
          this.input.addEventListener('input', this.onInput);
          this.input.addEventListener('input', this.syncGhost);
          this.input.addEventListener('pointerdown', this.onFieldPointer);
          this.input.addEventListener('focus', this.onFieldPointer);
          this.input.addEventListener('keydown', this.onInputKey);
          this.input.addEventListener('blur', this.resumeTypewriter);
        }
        var field = this.querySelector('.ens__field');
        if (field) field.addEventListener('pointerdown', this.onFieldPointer);
        if (this.form) this.form.addEventListener('submit', this.onFormSubmit.bind(this));
        if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmitClick);
        if (this.clearBtn) this.clearBtn.addEventListener('click', this.onClear.bind(this));
        if (this.results) this.results.addEventListener('click', this.onResultsClick.bind(this));
        window.addEventListener('resize', this.place);
        this.classList.add('ens--no-form-anim');
        this.place();
        if (this.isMobile()) this.startTypewriter();
        var self = this;
        requestAnimationFrame(function () {
          self.place();
          requestAnimationFrame(function () {
            self.classList.remove('ens--no-form-anim');
          });
        });
      }

      disconnectedCallback() {
        this.stopTypewriter();
        this.unlockPage();
        document.removeEventListener('click', this.onToggle);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('resize', this.place);
        this.dockForm(false);
      }

      onToggle(event) {
        var trigger = event.target.closest('[data-open-enova-search]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.hasAttribute('open')) this.close();
        else this.open(trigger);
      }

      isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
      }

      focusInput() {
        if (!this.input || typeof this.input.focus !== 'function') return;
        try {
          this.input.focus({ preventScroll: true });
        } catch (err) {
          this.input.focus();
        }
      }

      onFormSubmit(event) {
        if (this.isMobile() && !this.hasAttribute('open')) {
          event.preventDefault();
          this.open();
          return;
        }
        if (this.input && !this.input.value.trim()) {
          event.preventDefault();
          this.open();
        }
      }

      onSubmitClick(event) {
        if (!this.isMobile()) return;
        event.preventDefault();
        if (this.hasAttribute('open')) this.close();
        else this.open();
      }

      syncSubmitMode() {
        if (!this.submitBtn) return;
        if (this.isMobile()) {
          this.submitBtn.setAttribute('type', 'button');
          this.submitBtn.setAttribute(
            'aria-label',
            this.hasAttribute('open') ? 'Cerrar buscador' : 'Buscar'
          );
          return;
        }
        this.submitBtn.setAttribute('type', 'submit');
        this.submitBtn.setAttribute('aria-label', 'Buscar');
      }

      onPanelClick(event) {
        if (event.target.closest('[data-ens-close]')) {
          this.close();
          return;
        }
        var tag = event.target.closest('[data-ens-tag]');
        if (tag && this.input) {
          event.preventDefault();
          this.input.value = tag.textContent.trim();
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.focus();
        }
      }

      onKey(event) {
        if (event.key === 'Escape') this.close();
      }

      onClear(event) {
        event.preventDefault();
        this.input.value = '';
        this.search();
        this.pauseTypewriter();
        this.input.focus();
      }

      open(trigger) {
        if (this.hasAttribute('open')) return;
        this.lastFocus = trigger || document.activeElement;
        this.hidden = false;
        this.removeAttribute('hidden');
        this.panel.setAttribute('aria-hidden', 'false');
        this.lockPage();
        this.syncTriggers(true);
        this._userInInput = false;
        this.setAttribute('open', '');
        this.syncSubmitMode();
        this.place();
        document.addEventListener('keydown', this.onKey);
        this.focusInput();
        if (!this.hasQuery()) this.startTypewriter();
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openSearchPopup, this);
        }
      }

      close() {
        if (!this.hasAttribute('open')) return;
        this._userInInput = false;
        this.stopTypewriter();
        this.finishClose();
      }

      finishClose() {
        this.removeAttribute('open');
        this.panel.setAttribute('aria-hidden', 'true');
        this.unlockPage();
        this.syncTriggers(false);
        this.syncSubmitMode();
        document.removeEventListener('keydown', this.onKey);
        if (this.isMobile()) {
          this.hidden = false;
          this.removeAttribute('hidden');
          var self = this;
          requestAnimationFrame(function () {
            self.place();
            if (!self.hasQuery()) self.startTypewriter();
          });
          return;
        }
        this.place();
        var self = this;
        setTimeout(function () {
          if (!self.hasAttribute('open')) self.hidden = true;
        }, 280);
        if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
          try {
            this.lastFocus.focus({ preventScroll: true });
          } catch (err) {
            this.lastFocus.focus();
          }
        }
      }

      lockPage() {
        if (this._locked) return;
        this._locked = true;
        this._scrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('ens-search-open');
        document.body.classList.add('ens-search-open');
        document.body.style.top = '-' + this._scrollY + 'px';
        document.addEventListener('wheel', this.onGuardScroll, { passive: false });
        document.addEventListener('touchmove', this.onGuardScroll, { passive: false });
      }

      unlockPage() {
        if (!this._locked) return;
        this._locked = false;
        document.documentElement.classList.remove('ens-search-open');
        document.body.classList.remove('ens-search-open');
        document.body.style.top = '';
        document.removeEventListener('wheel', this.onGuardScroll);
        document.removeEventListener('touchmove', this.onGuardScroll);
        window.scrollTo(0, this._scrollY || 0);
      }

      onGuardScroll(event) {
        if (!this.hasAttribute('open')) return;
        if (event.target && event.target.closest && event.target.closest('.ens__scroll')) return;
        event.preventDefault();
      }

      syncTriggers(open) {
        document.querySelectorAll('[data-open-enova-search]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.setAttribute('aria-label', open ? 'Cerrar buscador' : 'Buscar');
        });
      }

      place() {
        this.syncSubmitMode();
        var wrap = document.querySelector('.m-header__wrapper');
        if (this.isMobile()) {
          this.classList.add('ens--docked');
          this.hidden = false;
          this.removeAttribute('hidden');
          document.documentElement.classList.add('ens-mobile-docked');
          this.dockForm(true);
          var header = document.querySelector('.m-header__mobile');
          var logo = document.querySelector('.m-header__mobile .m-logo, .m-header__mobile .m-logo__image');
          var cart = document.querySelector('.m-header__mobile .m-cart-icon-bubble') ||
            document.querySelector('.m-header__mobile [href*="/cart"]');
          var headerRect = header ? header.getBoundingClientRect() : null;
          var headerBottom = headerRect ? Math.round(headerRect.bottom) : 80;
          this.style.setProperty('--ens-top', headerBottom + 'px');
          var top;
          var left;
          var width;
          if (this.hasAttribute('open')) {
            left = 10;
            width = Math.max(160, Math.round(window.innerWidth - 10 - left));
            top = headerRect
              ? Math.round(headerRect.top + (headerRect.height - 42) / 2)
              : headerBottom + 8;
          } else if (headerRect) {
            var logoRight = logo ? logo.getBoundingClientRect().right : headerRect.left + 72;
            var cartLeft = cart ? cart.getBoundingClientRect().left : headerRect.right - 48;
            left = Math.round(logoRight + 18);
            width = Math.round(Math.max(120, cartLeft - 10 - left));
            top = Math.round(headerRect.top + (headerRect.height - 38) / 2);
          } else {
            return;
          }
          this.style.setProperty('--ens-form-top', top + 'px');
          this.style.setProperty('--ens-form-left', left + 'px');
          this.style.setProperty('--ens-form-width', width + 'px');
          if (this.form) {
            this.form.style.setProperty('--ens-form-top', top + 'px');
            this.form.style.setProperty('--ens-form-left', left + 'px');
            this.form.style.setProperty('--ens-form-width', width + 'px');
          }
          return;
        }
        this.classList.remove('ens--docked');
        document.documentElement.classList.remove('ens-mobile-docked');
        this.dockForm(false);
        var top = wrap ? Math.round(wrap.getBoundingClientRect().bottom) : 80;
        this.style.setProperty('--ens-top', top + 'px');
      }

      dockForm(dock) {
        if (!this.form) return;
        if (dock) {
          this.form.classList.add('ens-form-docked');
          if (this.form.parentElement !== document.body) {
            this._formHome = this.form.parentNode;
            this._formNext = this.form.nextSibling;
            document.body.appendChild(this.form);
          }
          return;
        }
        this.form.classList.remove('ens-form-docked');
        if (this._formHome && this.form.parentElement !== this._formHome) {
          this._formHome.insertBefore(this.form, this._formNext);
        }
      }

      hasQuery() {
        return !!(this.input && this.input.value.trim());
      }

      onFieldPointer(event) {
        if (event && event.target && event.target.closest && event.target.closest('.ens__submit, .ens__clear')) return;
        this.pauseTypewriter();
        if (this.isMobile() && !this.hasAttribute('open')) this.open();
      }

      onInputKey(event) {
        if (event.key === 'Escape' || event.key === 'Tab') return;
        this.pauseTypewriter();
      }

      pauseTypewriter() {
        this._userInInput = true;
        this.stopTypewriter();
        if (this.ghost) {
          this.ghost.hidden = true;
          this.ghost.textContent = '';
        }
        if (this.input) this.input.classList.remove('ens__input--ghosting');
      }

      resumeTypewriter() {
        this._userInInput = false;
        if (this.hasQuery()) return;
        if (this.hasAttribute('open') || (this.isMobile() && this.classList.contains('ens--docked'))) {
          this.startTypewriter();
        }
      }

      syncGhost() {
        var busy = this.hasQuery();
        var paused = this._userInInput;
        if (this.ghost) this.ghost.hidden = busy || paused;
        if (this.input) this.input.classList.toggle('ens__input--ghosting', !busy && !paused);
        if (busy || paused) this.stopTypewriter();
        else if ((this.hasAttribute('open') || this.classList.contains('ens--docked')) && !this._twTimer) this.startTypewriter();
      }

      startTypewriter() {
        this.stopTypewriter();
        if (this._userInInput) return;
        if (!this.ghost || !this.phrases.length) return;
        if (this.hasQuery()) {
          this.ghost.hidden = true;
          if (this.input) this.input.classList.remove('ens__input--ghosting');
          return;
        }
        this.ghost.hidden = false;
        if (this.input) this.input.classList.add('ens__input--ghosting');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.ghost.textContent = this.phrases[0];
          return;
        }
        this._twIndex = 0;
        this._twPos = 0;
        this._twDeleting = false;
        this.ghost.textContent = '';
        this.tickTypewriter();
      }

      stopTypewriter() {
        if (this._twTimer) {
          clearTimeout(this._twTimer);
          this._twTimer = null;
        }
      }

      tickTypewriter() {
        var self = this;
        if (!this.ghost || this.ghost.hidden || !this.phrases.length) return;
        var phrase = this.phrases[this._twIndex] || '';
        var delay;

        if (!this._twDeleting) {
          this._twPos += 1;
          this.ghost.textContent = phrase.slice(0, this._twPos);
          if (this._twPos >= phrase.length) {
            this._twDeleting = true;
            delay = 2200;
          } else {
            delay = 55;
          }
        } else {
          this._twPos -= 1;
          this.ghost.textContent = phrase.slice(0, Math.max(0, this._twPos));
          if (this._twPos <= 0) {
            this._twDeleting = false;
            this._twIndex = (this._twIndex + 1) % this.phrases.length;
            delay = 420;
          } else {
            delay = 28;
          }
        }

        this._twTimer = setTimeout(function () { self.tickTypewriter(); }, delay);
      }

      search() {
        var term = this.input ? this.input.value.trim() : '';
        if (this.clearBtn) this.clearBtn.hidden = term.length === 0;
        if (!term) {
          this.showDiscover();
          return;
        }
        var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
        if (!routes.predictive_search_url) return;

        if (this.cache[term]) {
          this.renderResults(this.cache[term]);
          return;
        }

        this.toggleSpinner(true);
        var fields = 'title,product_type,vendor,variants.sku,variants.title';
        var url = routes.predictive_search_url +
          '?q=' + encodeURIComponent(term) +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=' + fields +
          '&section_id=predictive-search';

        var self = this;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var root = doc.querySelector('#shopify-section-predictive-search');
            var html = root ? root.innerHTML : '';
            if (!html || html.indexOf('Liquid error') !== -1) {
              self.toggleSpinner(false);
              return;
            }
            self.cache[term] = html;
            self.renderResults(html);
          })
          .catch(function () { self.toggleSpinner(false); });
      }

      renderResults(html) {
        this.toggleSpinner(false);
        if (this.discover) this.discover.hidden = true;
        if (this.results) {
          this.results.hidden = false;
          this.results.innerHTML = html;
          this.enhanceResults();
        }
        this.showAllLink();
      }

      onResultsClick(event) {
        var addBtn = event.target.closest('[data-ens-add]');
        if (!addBtn) return;
        event.preventDefault();
        event.stopPropagation();
        this.addFromButton(addBtn);
      }

      shopRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      firstAvailableVariant(product) {
        var variants = (product && product.variants) || [];
        var i;
        for (i = 0; i < variants.length; i++) {
          if (variants[i] && variants[i].available) return variants[i];
        }
        return null;
      }

      addFromButton(btn) {
        var self = this;
        if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        var original = btn.getAttribute('data-label') || 'Agregar';
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        var cached = this._productCache[handle];
        var load = cached
          ? Promise.resolve(cached)
          : fetch(this.shopRoot() + 'products/' + encodeURIComponent(handle) + '.js')
              .then(function (res) { return res.json(); });

        load
          .then(function (product) {
            self._productCache[handle] = product;
            var variant = self.firstAvailableVariant(product);
            if (!variant) {
              btn.textContent = 'Agotado';
              btn.removeAttribute('aria-busy');
              return null;
            }
            var form = new FormData();
            form.append('id', String(variant.id));
            form.append('quantity', '1');
            var cart = document.querySelector('m-cart-drawer');
            if (cart && typeof cart.getSectionsToRender === 'function') {
              form.append('sections', cart.getSectionsToRender().map(function (section) { return section.id; }));
              form.append('sections_url', window.location.pathname);
            }
            var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
            var url = routes.cart_add_url || (self.shopRoot() + 'cart/add.js');
            return fetch(url, {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
              body: form
            }).then(function (res) { return res.json(); });
          })
          .then(function (response) {
            if (!response) return;
            if (response.status) throw new Error(response.description || response.message || 'Error');
            var cart = document.querySelector('m-cart-drawer');
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
              cart.classList.remove('m-cart--empty');
            }
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, response);
            }
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
            btn.removeAttribute('aria-busy');
            btn.textContent = 'Agregado';
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            }, 1400);
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
      }

      enhanceResults() {
        if (!this.results) return;
        this.results.querySelectorAll('.m-search-result__group').forEach(function (group) {
          if (!group.querySelector('.m-search-result__products')) group.remove();
        });
        var block = this.results.querySelector('.m-search-result__products');
        var list = block && block.querySelector('.m-search-result__products-list');
        if (!block || !list) return;

        var items = list.querySelectorAll('.m-search-item--with-thumbnail');
        if (!items.length) return;

        var rows = [];
        items.forEach(function (item) {
          if (item.querySelector('.m-product-tag--soldout, .m-price--sold-out')) return;
          var href = item.getAttribute('href') || '#';
          var img = item.querySelector('img');
          var titleEl = item.querySelector('.m-search-item--title');
          var title = titleEl ? titleEl.textContent.trim() : '';
          var price = extractPriceHtml(item);
          var src = img ? upscaleImage(img.getAttribute('src') || '') : '';
          var handle = productHandleFromHref(href);
          rows.push(
            '<div class="ens-rrow">' +
              '<a class="ens-rrow__media" href="' + escapeHtml(href) + '" tabindex="-1" aria-hidden="true">' +
                (src ? '<img src="' + escapeHtml(src) + '" alt="" loading="lazy">' : '') +
              '</a>' +
              '<a class="ens-rrow__body" href="' + escapeHtml(href) + '">' +
                '<span class="ens-rrow__title">' + escapeHtml(title) + '</span>' +
                (price ? '<span class="ens-pcard__price">' + price + '</span>' : '') +
              '</a>' +
              (handle
                ? '<button type="button" class="ens-rrow__add" data-ens-add data-handle="' +
                  escapeHtml(handle) +
                  '" data-label="Agregar">Agregar</button>'
                : '') +
            '</div>'
          );
        });

        var heading = block.querySelector('.m-search-result__heading');
        var head = document.createElement('div');
        head.className = 'ens-results-head';
        if (heading) {
          heading.textContent = 'Resultado de búsqueda:';
          head.appendChild(heading);
        }

        var listEl = document.createElement('div');
        listEl.className = 'ens-rlist';
        listEl.innerHTML = rows.join('');

        block.innerHTML = '';
        block.appendChild(head);
        block.appendChild(listEl);
      }

      showAllLink() {
        if (!this.allBtn || !this.form) return;
        var params = new URLSearchParams(new FormData(this.form));
        this.allBtn.href = this.form.getAttribute('action') + '?' + params.toString();
        this.allBtn.hidden = false;
      }

      hideAllLink() {
        if (this.allBtn) this.allBtn.hidden = true;
      }

      showDiscover() {
        this.toggleSpinner(false);
        if (this.results) {
          this.results.hidden = true;
          this.results.innerHTML = '';
        }
        if (this.discover) this.discover.hidden = false;
        if (this.clearBtn) this.clearBtn.hidden = true;
        this.hideAllLink();
      }

      toggleSpinner(show) {
        if (this.spinner) this.spinner.hidden = !show;
      }
    }

    window.customElements.define('enova-search-panel', EnovaSearchPanel);
  })();

  } catch(e) { console.error(e); }
})();
})();
